import { register, find } from '../../../Javascript/Utils.js'

const JWPlayer = el => {
  function loadJWPlayer () {
    const playerPane = find('.js-jwplayer-pane', el)
    // player config (this could be seperated one day, e.g. call video with playerkey and config_id):
    const playerBaseURL = 'https://cdn.jwplayer.com/libraries/'
    const videoBaseUrl = 'https://cdn.jwplayer.com/v2/media/'
    const skinUrl = '/_assets/10e37ff572203ebb607800d34039d6fc/JWPlayer/skin.css?20220511'
    const skinName = 'spgl'
    // player init:
    if (playerPane) {
      const videoCfg1 = el.getAttribute('data-cfg')
      const videoCfg = JSON.parse(videoCfg1)
      const videourl = videoBaseUrl + videoCfg.vid
      const playerurl = playerBaseURL + videoCfg.pk + '.js'
      const myScriptId = 'jwplayer_' + videoCfg.pk
      let myScript = document.getElementById(myScriptId)
      // load the player lib:
      if (myScript === null) {
        myScript = document.createElement('script')
        myScript.src = playerurl
        myScript.id = myScriptId
        el.appendChild(myScript)
      }
      // video init only works after player lib is fully loaded:
      const prevLoad = myScript.onload
      myScript.onload = function () {
        if (prevLoad) {
          prevLoad()
        }
        window.jwplayer(playerPane).setup({
          playlist: videourl,
          skin: {
            url: skinUrl,
            name: skinName
          }
        })
      }
    }
  }

  if (typeof window.Cookiebot === 'undefined' || window.Cookiebot.consent.marketing) {
    loadJWPlayer()
  } else {
    window.addEventListener('CookiebotOnAccept', function (event) {
      if (window.Cookiebot.consent.marketing) {
        loadJWPlayer()
      } else {
        window.jwplayer().stop()
      }
    })
  }
  window.addEventListener('CookiebotOnDecline', function (event) {
    window.jwplayer().stop()
  })
}

register('JWPlayer', JWPlayer)
